import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import FilterItemWrapper from '../fields/FilterItemWrapper';
import Input from '../fields/Input';

export type PowerFactorFilter = {
  name?: string;
  sortBy?:
    | 'id'
    | 'name'
    | undefined;
  descending?: boolean;
};

export type PowerFactorFiltersProps = {
  updateFilter: (key: string, value: string | undefined) => void;
  filter: PowerFactorFilter;
};

const GroupsFilters: FC<PowerFactorFiltersProps> = ({
  updateFilter,
  filter,
}) => {
  const { t } = useTranslation();

  const filters = () => {
    return [
      <Input
        key="name"
        name="name"
        onChange={(value) => updateFilter('name', value as string)}
        onBlur={() => {}}
        error=""
        required={false}
        label={t('powerFactorSettingsPage.name')}
        value={filter.name || ''}
      />,
    ];
  };

  return (
    <>
      {filters().map((filter) => (
        <FilterItemWrapper key={filter.key}>{filter}</FilterItemWrapper>
      ))}
    </>
  );
};

export default GroupsFilters;
